import { IComponentManifest } from "flow/manifests/ManifestInterfaces";

export default class ProductConfigManifest {
    cacheBuster: string;
    customOptionsComponent: IComponentManifest;
    hide: boolean;
    metaConfig: object;
    inactiveReason: string;
}
